import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3 1.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z M14.507 7.13a1.62 1.62 0 0 1 0 1.74C12.905 11.38 10.25 13 8 13s-4.905-1.62-6.507-4.13a1.615 1.615 0 0 1 0-1.74C3.095 4.62 5.75 3 8 3s4.905 1.62 6.507 4.13Zm-.843 1.202a.615.615 0 0 0 0-.664C12.194 5.366 9.824 4 8 4 6.177 4 3.806 5.366 2.336 7.668a.615.615 0 0 0 0 .664C3.806 10.634 6.176 12 8 12c1.823 0 4.194-1.366 5.664-3.668Z';
const draw24px =
  'M22.74,11.84a.43.43,0,0,0,0-.05C22.34,10,17.33,5.08,12,5.08s-10.42,5-10.73,6.76a.88.88,0,0,0,0,.16.66.66,0,0,0,0,.23c.42,1.78,5.32,6.61,10.56,6.69h.3c5.26-.08,10.18-5,10.57-6.71a.11.11,0,0,0,0-.05.65.65,0,0,0,0-.32ZM12,17.43c-4.55,0-8.81-4.36-9.23-5.43C3.23,10.91,7.49,6.58,12,6.58s8.81,4.36,9.23,5.43C20.79,13.1,16.54,17.43,12,17.43ZM12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16ZM12,9.5a2.51,2.51,0,1,0,2.5,2.5A2.5,2.5,0,0,0,12,9.5Z';
const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const EyeIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'eye'),
) as IconWithRender;

EyeIcon.displayName = 'EyeIcon';
EyeIcon.propTypes = Icon.propTypes;
EyeIcon.renderIcon = (props) => <EyeIcon {...props} />;
export default EyeIcon;
